<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="menu.seedingPositionConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="positionType.name" title="business.label.positionType"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoomName"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="visualized" title="business.label.visualized" width="60"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" title="menu.seedingPositionConfig" type="confirm" width="30%" @confirm="confirm">
      <vxe-form ref="form" :data="config" :rules="rules" span="12">
        <vxe-form-item :item-render="{name:'VxeSelect',options:positionTypes}" field="positionType.id" title="business.label.positionType"/>
        <vxe-form-item :item-render="{name:'VxeInput',events:{click:()=>onStorageRoomSelect(),clear:()=>onInputChange(config,'storageRoom')}}" field="storageRoom.name" title="business.label.storageRoomName"/>
        <vxe-form-item :item-render="{name:'VxeSwitch'}" field="visualized" title="business.label.visualized"/>
      </vxe-form>
    </vxe-modal>
    <storage-room-modal ref="storageRoomModal" @change="(values)=>onInputChange(config,'storageRoom',values[0])"/>
  </div>
</template>

<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { SeedingPositionConfig } from '@/api/dto/config/SeedingPositionConfig'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { onInputChange } from '@/utils/util'

export default {
  components: { StorageRoomModal },
  props: {
    positionTypes: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      visible: false,
      warehouse: new Warehouse(),
      list: [],
      config: new SeedingPositionConfig(),
      rules: {
        'positionType.id': [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    onInputChange,
    onStorageRoomSelect(row) {
      this.$refs.storageRoomModal.open({ available: true, physical: true }, row)
    },
    refresh(warehouse) {
      this.warehouse = warehouse
      if (this.warehouse.isNew()) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('seedingPositionConfigFactory', { 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new SeedingPositionConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new SeedingPositionConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('seedingPositionConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new SeedingPositionConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      save('seedingPositionConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new SeedingPositionConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.warehouse)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('seedingPositionConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.warehouse)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>